import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import ErrorMessage, { AuthenticationError } from './ErrorMessage';

export class ComponentErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (!prevProps.location || location.pathname !== prevProps.location.pathname) {
      this.clearError();
    }
  }

  componentDidCatch(error) {
    if (error instanceof AuthenticationError) throw error;
    this.setState({ error });
  }

  clearError() {
    this.setState({ error: null });
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    return error ? <ErrorMessage error={error} /> : children;
  }
}

ComponentErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
  location: PropTypes.shape().isRequired,
};

export default withRouter(ComponentErrorBoundary);



// WEBPACK FOOTER //
// ./src/layout/ComponentErrorBoundary.jsx